<template>
  <v-row class="ma-0">
    <v-col cols="12" class="text-center pa-0 pt-5">
      <v-date-picker
        v-model="dates"
        range
        full-width
        no-title
        color="blue"
        @input="dateChanged"
        :weekday-format="getDay"
        :month-format="getMonth"
        :header-date-format="getHeaderDate"
        :min="minDate"
        :max="maxDate"
        :events="events"
        :event-color="eventColor"
        :show-current="true"
      />
    </v-col>
  </v-row>
</template>
<script>
import { getDay, getMonth } from '@/utils/common/datePicker.js';
import { mapGetters, mapMutations } from 'vuex';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import { getHolReplaceCalendarPeriodMonList } from '@/api/calendar.js';
import { getHolReplaceAppDetHoliChk } from '@/api/workStatus';
import { getOrgHolidayList } from '@/api/calendar.js';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
dayjs.locale('ko');
/**
 * 날짜 선택 컴포넌트
 * 신청서 별 선택일자 유효성 검사
 * */
export default {
  mixins: [applCdMixin],
  data: () => ({
    dates: [],
    minDate: '',
    maxDate: '',
    currDate: '',
    events: [],
    gntTextColorObj: {
      bcFFD49A: 'ff7936',
      bcFFE79A: 'ff9204',
      bcA6E5BA: '0fa941',
      bc9CCBFC: '087ef7',
      bcD7DADD: '505961',
    },
    eventColor: {},
    selectMonth: '',
    count: 0,
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_DATE_TYPE',
      'GET_REQUEST_HOUR',
      'GET_REWARD_LIST',
    ]),
    ...mapGetters(['GET_WORK_TYPE_CD', 'GET_USER_DATA']),

    isStartDatePage() {
      return (
        this.$route.name === routerNames.StartDate ||
        this.isAnnualPlanWritePage ||
        routerNames.StartDateAppl
        // 연차계획작성도 같은 로직으로 처리
      );
    },
    isEndDatePage() {
      return this.$route.name === routerNames.EndDate;
    },
    // 연차계획작성 페이지 여부
    isAnnualPlanWritePage() {
      return this.$route.name === routerNames.AnnualPlanWrite;
    },
    vacationValidCheckNeed() {
      return (
        this.isEndDatePage ||
        (this.isStartDatePage &&
          (this.GET_DATE_TYPE === 'OD' || this.GET_DATE_TYPE === 'H'))
      );
    },
  },

  methods: {
    ...mapMutations('ELA', [
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_WORK_YMD',
      'SET_WORK_WEEK',
      'SET_STD_YMD',
      'SET_REQ_TIME',
      'SET_USE_REWARD_LIST',
    ]),

    /* 캘린더 일정 컬러 */
    getEventColor(event) {
      return event.color;
    },
    getEventTextColor(event) {
      return event.textColor;
    },

    /* 날짜선택시 */
    async dateChanged(dateArr) {
      this.ON_APP_SPINNER(); // 스피너 ON

      //this.isStartDatePage = false;
      const date = this.fetchDate(dateArr);

      this.$emit('selectDate', date);

      this.OFF_APP_SPINNER(); // 스피너 ON
    },

    //스케쥴 및 휴일 체크
    async dateCheck(date) {


      return true;
    },
    formatDate(strDate, saper) {
      if (strDate == '' || strDate == null) {
        return '';
      }

      if (strDate.length == 10) {
        return (
          strDate.substring(0, 4) +
          saper +
          strDate.substring(5, 7) +
          saper +
          strDate.substring(8, 10)
        );
      } else if (strDate.length == 8) {
        return (
          strDate.substring(0, 4) +
          saper +
          strDate.substring(4, 6) +
          saper +
          strDate.substring(6, 8)
        );
      } else if (strDate.length == 6) {
        return strDate.substring(0, 4) + saper + strDate.substring(4, 6);
      }
    },

    // 근태
    async validateVacationDet(date) {
      this.SET_E_YMD(date);

      const result = await this.$store.dispatch('ELA/VALIDATE_VACATION_DET');
      // 신청불가 초기화, 시작일자 선택화면으로
      if (!result) {
        this.dates = [];
        if (this.isEndDatePage) window.history.go(-1);
      }

      return result;
    },

    // 연장근무
    async validateOtWorkDet(date) {
      this.SET_WORK_YMD(date);
      this.SET_WORK_WEEK(dayjs(date).format('ddd'));

      const result = await this.$store.dispatch('ELA/VALIDATE_OT_WORK_STATUS');
      if (!result) this.dates = [];
      return result;
    },

    // 근무스케줄
    async validateScheduleDet(date) {
      this.SET_STD_YMD(date);
      this.SET_E_YMD(date);

      // 기 신청건 체크
      const result1 = await this.$store.dispatch('ELA/VALIDATE_SCHEDULE_DET');
      if (!result1) {
        this.dates = [];
        return result1;
      }

      // 상태확인 및 스케줄 정보 조회
      const result2 = await this.$store.dispatch(
        'ELA/VALIDATE_SCHEDULE_STATUS',
      );
      if (!result2) {
        this.dates = [];
        return result2;
      }

      return result2;
    },

    // 보상휴가
    async validateRewardDet(date) {
      this.SET_E_YMD(date);

      const result1 = await this.$store.dispatch('ELA/VALIDATE_REWARD_DET');
      // 신청불가 초기화, 시작일자 선택화면으로
      if (!result1) {
        this.dates = [];
        if (this.isEndDatePage) window.history.go(-1);
        return result1;
      }

      await this.$store.dispatch('ELA/FETCH_REWARD_HOLI_CNT');
      await this.$store.dispatch('ELA/FETCH_REWARD_LIST');

      if (this.GET_REWARD_LIST.length === 0) {
        alert('해당일자에 사용가능한 보상이 없습니다.');
        this.dates = [];
        return false;
      }

      const result2 = this.rewardTimeCalc();
      if (!result2) this.dates = [];
      return result2;
    },

    // 보상휴가 사용시간 계산
    async rewardTimeCalc() {
      let result = false;

      // 사용시간 계산
      let useRewardList = [];
      let reqTime = this.GET_REQUEST_HOUR;

      this.GET_REWARD_LIST.forEach(reward => {
        if (reward.restTime === 0 || reqTime === 0) {
          reward.useTime = 0;
        } else if (reqTime > reward.restTime) {
          reward.useTime = reward.restTime;
          reqTime -= reward.restTime;
          useRewardList.push(reward);
        } else {
          reward.useTime = reqTime;
          reqTime = 0;
          useRewardList.push(reward);
        }
      });

      this.SET_REQ_TIME(reqTime);
      this.SET_USE_REWARD_LIST(useRewardList);

      if (reqTime > 0) {
        // 신청불가 초기화, 시작일자 선택화면으로 20230118 ejkim
        alert('사용가능한 보상시간이 부족합니다.');
        this.dates = [];
        if (this.isEndDatePage) window.history.go(-1);
        return result;
      }

      return !result;
    },

    // 출퇴근변경신청
    async validateAttendDet(date) {
      this.SET_WORK_YMD(date);
      this.SET_WORK_WEEK(dayjs(date).format('ddd'));

      // 기 신청건 체크
      const result1 = await this.$store.dispatch('ELA/VALIDATE_ATTEND_DET');
      if (!result1) {
        this.dates = [];
        return result1;
      }

      const result2 = await this.$store.dispatch('ELA/VALIDATE_ATTEND_STATUS');
      if (!result2) this.dates = [];
      return result2;
    },

    // 연차계획작성
    async validateAnnualPlanDet(date) {
      this.SET_S_YMD(date);
      this.SET_E_YMD(date);

      const result = await this.$store.dispatch('ELA/VALIDATE_PLAN_DET');
      // 신청불가 초기화, 시작일자 선택화면으로
      if (!result) this.dates = [];
      return result;
    },

    fetchDate(dateArr) {
      /*
      if (this.isStartDatePage) {
        return dateArr[0].replaceAll('-', '');
      } else {
        //ejkim 종료일 선택이 없을경우 ''처리  20230118  by ejkim
        if (dateArr[1] !== undefined) {
          return dateArr[1].replaceAll('-', '');
        } else {
          return '';
        }
        //return dateArr[1].replaceAll('-', '');
      }
      */
      return dateArr.length > 1
        ? dateArr[1].replaceAll('-', '')
        : dateArr[0].replaceAll('-', '');
    },

    resetDate() {
      this.SET_S_YMD('');
      this.SET_E_YMD('');
      window.history.go(-1);
    },

    /* 월단위 캘린더 목록조회 */
    async getPsnlCalendarMonList() {
      try {
        // 1. api 호출
        /*
        const response = await getHolReplaceCalendarPeriodMonList({
          searchYm: dayjs(this.selectMonth).format('YYYYMM'),
          replaceGubun: this.GET_WORK_TYPE_CD,
        });
        */

        const dataList = [];//response.data.data;
        // 2. 초기화
        let event = []; // [날짜,...]
        let eventColor = {}; // {날짜 : [색,...]}
        this.dailyInOutTimeObj = {};

        //const statusArr = ['21', '31']; // 결재처리중

        // 3. 캘린더 노출 데이터 셋팅
        dataList.forEach(item => {
          // eslint-disable-next-line no-unused-vars
          let backColor = '#ffbebe'; // 기본 : 휴일컬러
          if (item.cls != null) {
            backColor = `#${item.cls.substr(2).toLocaleLowerCase()}`;
          }

          event.push(item.sYmd);

          let idx = 0;
          // 기간

          const date = dayjs(item.sYmd)
            .add(idx++, 'day')
            .format('YYYY-MM-DD');
          event.push(date);

          if (item.chkYn === 'Y') {
            eventColor[date] !== undefined
              ? eventColor[date].push(backColor)
              : (eventColor[date] = [backColor]);
          }
        });

        let params = {
          enterCd : this.GET_USER_DATA.ssnEnterCd
        , sabun : this.GET_USER_DATA.ssnSabun
        , startYm: dayjs(this.selectMonth).format('YYYYMM')
        }

        let response = await getOrgHolidayList(params);

        const holidayList = response.data.data;

        // 3. 캘린더 노출 데이터 셋팅
        holidayList.forEach(item => {
          // eslint-disable-next-line no-unused-vars
          let backColor = '#ffbebe'; // 기본 : 휴일컬러
          if (item.cls != null) {
            backColor = `#${item.cls.substr(2).toLocaleLowerCase()}`;
          }

          event.push(item.ymd);

          let idx = 0;
          // 기간

          const date = dayjs(item.ymd)
            .add(idx++, 'day')
            .format('YYYY-MM-DD');

          event.push(date);

            eventColor[date] !== undefined
              ? eventColor[date].push(backColor)
              : (eventColor[date] = [backColor]);

        });

        // 4. 캘린더 일정 추가
        this.events = event;
        this.eventColor = eventColor;
      } catch (error) {
        console.log(error);
      }
    },

    getHeaderDate(date) {
      let month = getMonth(date);
      let year = new Date(date).getFullYear(date);
      let returnDate = date.length == 4 ? `${year}년` : `${year}년 ${month}`;
      this.selectMonth = date;

      if (date.length == 7 && date != this.currDate) {
        this.currDate = date;
        this.getPsnlCalendarMonList(dayjs(date).format(`YYYYMM`));
      }

      return returnDate;
    },

    getDay,
    getMonth,
  },
  created() {
    if (this.isEndDatePage) {
      this.dates[0] = this.GET_S_YMD;
    }

    if (this.isSchedule) {
      this.minDate = this.todayYMDHypen;
    }

    if (this.isAttend) {
      this.maxDate = ''; //this.todayYMDHypen;
    }

    this.currDate = this.todayYM;
  },
};
</script>
<style>
.v-date-picker-header .v-btn.v-btn--icon {
  color: #777e87;
}
.v-date-picker-table {
  height: 334px !important;
}
.v-date-picker-table--date td {
  height: 48px;
}
.v-date-picker-table td .v-btn__content {
  font-size: 0.8125rem;
}

.v-date-picker-table--date .v-date-picker-table__events {
  bottom: 2px !important;
}
</style>
